import * as turf from '@turf/turf'

/**
 *
 * @param feature
 * @description A filter that checks the validity for a filter
 * @returns {boolean}
 */
export const isValidFeature = (feature: any): boolean => {
  if (!isObject(feature)) return false
  if (!isFeatureType(feature?.type)) return false
  if (!isIdentifiable(feature?.id)) return false
  if (!hasProperties(feature?.properties)) return false
  if (!feature?.geometry?.type || !isValidGeometryType(feature.geometry.type)) return false
  try {
    turf.geojsonType(feature.geometry, feature.geometry.type, 'validGeometryFilter')
    return true
  } catch {
    console.log(`Error: Couldn't assert ${feature.geometry.type} - skipping ${feature.id}`)
    return false
  }
}

function isObject(obj: unknown): boolean {
  return typeof obj === 'object'
}

function isIdentifiable(id: unknown): boolean {
  if (typeof id !== 'string' && typeof id !== 'number' && typeof id !== undefined) return false
  return true
}

function isFeatureType(type: unknown): boolean {
  if (type !== 'Feature') return false
  return true
}

function isValidGeometryType(type: unknown): boolean {
  if (typeof type !== 'string') return false
  return [
    'Point',
    'MultiPoint',
    'LineString',
    'MultiLineString',
    'Polygon',
    'MultiPolygon',
    'GeometryCollection'
  ].includes(type)
}

function hasProperties(properties: unknown): boolean {
  if (typeof properties === 'object') return true
  return false
}
